const colorCache = new Map();

export const generateRandomColor = () => `#${Math.floor(Math.random() * 16777215).toString(16).padStart(6, '0')}`;

export const getOrGenerateColor = (routeId, colorMap = {}) => {
  if (colorMap[routeId]) {
    return colorMap[routeId];
  }

  if (colorCache.has(routeId)) {
    return colorCache.get(routeId);
  }

  const color = generateRandomColor();
  colorCache.set(routeId, color);
  return color;
};

export const clearColorCache = () => {
  colorCache.clear();
};
